import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CompletaPagamentoZero } from '../_classi/completaPagamentoZero';
import { InitPagamento } from '../_classi/InitPagamento';

@Injectable({
    providedIn: 'root'
})
export class ClientiService {

    formCliente = {
        formCarrello: null,
        formSpedizione: null,
        formTipoPagamento: null,
        salvata: false
    }

    constructor(
        private http: HttpClient
    ) { }

    inserisciClienteNF(valori): Observable<any> {
        return this.http.post(
            environment.apiUrl + 'public/',
            JSON.stringify(valori))
            .pipe(map(response => {
                return response;
            }));
    }

    inviaRichiestaSpedizioneEstera(valori): Observable<any> {
        return this.http.post(
            environment.apiUrl + 'public/',
            JSON.stringify(valori))
            .pipe(map(response => {
                return response;
            }));
    }

    getFormCliente() {
        return this.formCliente
    }

    setFormCliente(value) {
        this.formCliente = value;
    }
}
